export default "__VITE_ASSET__D7jNN5QP__"